var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "orderDetailInfo"
  }, [_c("a-spin", {
    attrs: {
      spinning: _vm.isTableLoading
    }
  }, [_c("a-row", {
    attrs: {
      type: "flex"
    }
  }, [_c("a-col", {
    attrs: {
      flex: 1
    }
  }, [_c("h3", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.baseInfo")))])]), _c("a-col")], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.orderNo")) + "：")]), _vm._v(_vm._s(_vm.BasicInfo.orderNo))]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.orderStutas")) + "：")]), _vm._v(_vm._s(_vm.BasicInfo.orderStatus == 1 ? _vm.$t("public.orderStatus2") : _vm.BasicInfo.orderStatus == 2 ? _vm.$t("public.orderStatus99") : _vm.$t("public.orderStatus7")))]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.orderDate")) + "：")]), _vm._v(_vm._s(_vm.BasicInfo.orderDate))]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.userInfo")) + "：")]), _c("router-link", {
    staticClass: "underline",
    attrs: {
      target: "_blank",
      to: {
        path: "/customermanager/editcustomer2",
        query: {
          erpCustomerId: _vm.BasicInfo.erpCustomerId,
          customerId: _vm.BasicInfo.customerId
        }
      }
    }
  }, [_c("div", {
    staticStyle: {
      display: "inline-block"
    }
  }, [_vm._v(" " + _vm._s(_vm.BasicInfo.erpCustomerCode + " " + _vm.BasicInfo.erpCustomerName) + " ")])]), _vm._v("   ")], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.payTitle")) + "：")]), _vm._v(_vm._s(_vm.BasicInfo.payWay))]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.deliveryWay")) + "：")]), _vm._v(_vm._s(_vm.BasicInfo.deliveryWay == 1 ? _vm.$t("orderList.deliveryMethod3") : _vm.BasicInfo.deliveryWay == 2 ? _vm.$t("orderList.deliveryMethod2") : _vm.$t("orderList.deliveryMethod1")))]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.customerNote2")) + "：")]), _c("a-tooltip", {
    attrs: {
      placement: "topLeft"
    }
  }, [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.BasicInfo.customerNote) + " ")]), _c("div", {
    staticStyle: {
      display: "inline-block",
      width: "60%"
    }
  }, [_c("div", {
    staticClass: "box_ellipsis"
  }, [_vm._v(_vm._s(_vm.BasicInfo.customerNote))])])], 2)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.userAgent")) + "：")]), _c("a-tooltip", {
    attrs: {
      placement: "topLeft"
    }
  }, [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.BasicInfo.userAgent) + " ")]), _c("div", {
    staticStyle: {
      display: "inline-block",
      width: "60%"
    }
  }, [_c("div", {
    staticClass: "box_ellipsis"
  }, [_vm._v(_vm._s(_vm.BasicInfo.userAgent))])])], 2)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.ddz")) + "：")]), _vm._v(_vm._s(_vm.BasicInfo.sellerName))]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailTransport.yuseiOrderNos")) + "：")]), _vm.BasicInfo.orderIdNo ? _vm._l(_vm.BasicInfo.orderIdNo, function (item, index) {
    return _c("router-link", {
      attrs: {
        target: "_blank",
        to: {
          path: "/orderDetail2",
          query: {
            id: item.id
          }
        }
      }
    }, [_vm._v(" " + _vm._s(index > 0 ? "、" + item.no : item.no) + " ")]);
  }) : _vm._e()], 2)], 1), _c("a-divider"), _c("a-row", {
    attrs: {
      type: "flex"
    }
  }, [_c("a-col", {
    attrs: {
      flex: 1
    }
  }, [_c("h3", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.addressInfo")))])]), _c("a-col")], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.name")) + "：")]), _vm._v(_vm._s(_vm.BasicInfo.userName))]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.phone")) + "：")]), _vm._v(_vm._s(_vm.BasicInfo.userPhone))]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.postCode")) + "：")]), _vm._v(_vm._s(_vm.BasicInfo.addressPost))]), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderDetailInfo.detailedAddress")) + " "), _c("a-tooltip", {
    attrs: {
      placement: "topLeft"
    }
  }, [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("orderDetailInfo.detailedAddressTips")) + " ")]), _c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 2), _vm._v(" ：")], 1), _vm._v(_vm._s(_vm.BasicInfo.provinceName + " " + _vm.BasicInfo.addressDetail))])], 1), _c("a-divider")], 1), _c("a-modal", {
    attrs: {
      title: _vm.$t("orderDetailInfo.addOrderNoteTitle"),
      destroyOnClose: "",
      maskClosable: false
    },
    on: {
      ok: _vm.serverNoteHandle
    },
    model: {
      value: _vm.serverNoteVisible,
      callback: function callback($$v) {
        _vm.serverNoteVisible = $$v;
      },
      expression: "serverNoteVisible"
    }
  }, [_c("a-form-model", {
    ref: "serverNoteRuleForm",
    attrs: {
      rules: _vm.serverNoteRules,
      model: _vm.serverNoteModalValue
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("orderDetailInfo.orderNote"),
      prop: "note"
    }
  }, [_c("a-textarea", {
    attrs: {
      "auto-size": {
        minRows: 3,
        maxRows: 5
      }
    },
    model: {
      value: _vm.serverNoteModalValue.note,
      callback: function callback($$v) {
        _vm.$set(_vm.serverNoteModalValue, "note", $$v);
      },
      expression: "serverNoteModalValue.note"
    }
  })], 1)], 1)], 1), _c("a-modal", {
    attrs: {
      title: _vm.$t("orderDetailInfo.orderNoteTitle"),
      destroyOnClose: "",
      maskClosable: false
    },
    on: {
      ok: _vm.orderNoteHandle
    },
    model: {
      value: _vm.orderNoteVisible,
      callback: function callback($$v) {
        _vm.orderNoteVisible = $$v;
      },
      expression: "orderNoteVisible"
    }
  }, [_c("a-form-model", {
    ref: "orderNoteRuleForm",
    attrs: {
      rules: _vm.orderNoteRules,
      model: _vm.orderNoteModalValue
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("orderDetailInfo.orderNote"),
      prop: "orderNote"
    }
  }, [_c("a-textarea", {
    attrs: {
      "auto-size": {
        minRows: 3,
        maxRows: 5
      }
    },
    model: {
      value: _vm.orderNoteModalValue.orderNote,
      callback: function callback($$v) {
        _vm.$set(_vm.orderNoteModalValue, "orderNote", $$v);
      },
      expression: "orderNoteModalValue.orderNote"
    }
  })], 1), _c("span", {
    staticStyle: {
      color: "#D81E06"
    }
  }, [_vm._v(_vm._s(_vm.$t("orderDetailInfo.orderNoteTips", [_vm.BasicInfo.langName])))]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("orderDetailInfo.orderNoteUrl"),
      prop: "pictrueUrl"
    }
  }, [_c("a-textarea", {
    attrs: {
      "auto-size": {
        minRows: 3,
        maxRows: 5
      }
    },
    model: {
      value: _vm.orderNoteModalValue.pictrueUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.orderNoteModalValue, "pictrueUrl", $$v);
      },
      expression: "orderNoteModalValue.pictrueUrl"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };